import { render, staticRenderFns } from "./GelenlerForm.vue?vue&type=template&id=0babd40e&"
import script from "./GelenlerForm.vue?vue&type=script&lang=js&"
export * from "./GelenlerForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports